import moment from "moment";
import React from "react";

import { SearchParams } from "../assets/interfaces/FX_POS_Interfaces";
import { toast } from "react-toastify";
const HelperService = {
  getFormatedDateForDetail(dt: any, format?: any) {
    if (dt) {
      var stillUtc = moment.utc(dt).toDate();
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc).local().format(
          // localStorage.getItem("date_format") + " hh:mm A" ??
          // "DD-MM-YYYY  hh:mm A"
          (localStorage.getItem("date_format") ?? "DD-MM-YYYY") + " hh:mm A"
        );
      }
    }
  },
  titleCase(str: any) {
    if (str !== "") {
      return str
        .toLowerCase()
        .split(" ")
        .map((word: any) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      return str;
    }
  },
  getFormatedDate(date: any, format?: string) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format(format ? format : "DD-MM-YYYY hh:mm A");
    }
  },
  getAPIFormatedDate(date: any) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format("YYYY-MM-DD");
    }
  },
  formatCurrency(
    amount: number | string,
    // currency: 'INR' | 'USD' | 'EUR' = 'INR',
    minimumFractionDigits: number = 2,
  ): string {
    if (amount === null || amount === undefined || amount === '') {
      return '0.00';
    }
    const currency = localStorage.getItem("currency") || "INR";
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits: minimumFractionDigits,
    }).format(Number(amount));

  },
  removeDialCodeFromMobile(mobileNumber: any, dialCode: any) {
    dialCode = "+" + dialCode.toString();
    if (mobileNumber.startsWith(dialCode)) {
      return mobileNumber.slice(dialCode.length);
    }
    return mobileNumber;
  },

  toQueryString(params: any) {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, String(value));
      }
    });

    return query.toString();
  },
  isValidEmail(email: string) {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.(com|in|net|org|co\.in)$/i;
    return regex.test(email);
  },
  checkFormEmptyFields(obj: any, excludedKeys: string[] = []): boolean {
    let emptyKeyFlag = false;
    const excludedKeysSet = new Set(excludedKeys);

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      // Skip excluded keys
      if (excludedKeysSet.has(key)) return;

      // ✅ Special case: validate email
      if (key === "email") {
        if (!this.isValidEmail(value)) {
          console.log("Invalid Email:", value);
          emptyKeyFlag = true;
        }
      }

      // ✅ Handle valid boolean false (e.g., is_active: false)
      if (typeof value === "boolean") {
        return; // false is valid
      }

      // ✅ Handle File or Blob — treat as non-empty
      if (value instanceof File || value instanceof Blob) {
        return;
      }

      // ✅ Handle Date
      if (value instanceof Date) {
        // Invalid date or empty
        if (isNaN(value.getTime())) {
          console.log("Invalid or Empty Date:", key);
          emptyKeyFlag = true;
        }
        return; // valid date → skip
      }

      // ✅ Check for emptiness for strings, numbers, nulls, or objects
      const isEmptyValue =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "object" && Object.keys(value).length === 0);

      if (isEmptyValue) {
        console.log("Empty Key:", key);
        emptyKeyFlag = true;
      }
    });

    return emptyKeyFlag;
  }

  ,
  formatTimeTo12Hour(time24: string): string {
    if (!time24) return "";

    const [hourStr, minuteStr] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
  },

  allowOnlyNumericValues(e: React.KeyboardEvent<HTMLInputElement>) {
    const key = e.key;
    // Allow: backspace, delete, tab, escape, enter, arrows
    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "Tab" ||
      key === "Escape" ||
      key === "Enter" || key === "." ||
      (key >= "0" && key <= "9") ||
      (e.ctrlKey && (key === "a" || key === "c" || key === "v" || key === "x")) ||
      (key.startsWith("Arrow"))
    ) {
      // allow only numeric and control keys, not alpha chars
      return;
    } else {
      e.preventDefault();
    }
  },
  getUnits(value: string) {
    const unitOptions = [
      { title: 'Gram', value: 'g' },
      { title: 'Kilogram', value: 'kg' },
      { title: 'Milligram', value: 'mg' },
      { title: 'Liter', value: 'l' },
      { title: 'Milliliter', value: 'ml' },
      { title: 'Cup', value: 'cup' },
      { title: 'Tablespoon', value: 'tbsp' },
      { title: 'Teaspoon', value: 'tsp' },
      { title: 'Piece', value: 'piece' },
      { title: 'Slice', value: 'slice' },
      { title: 'Bowl', value: 'bowl' },
      { title: 'Packet', value: 'packet' },
      { title: 'Bottle', value: 'bottle' },
      { title: 'Can', value: 'can' },
      { title: 'Dozen', value: 'dozen' },
      { title: 'Pint', value: 'pt' },
      { title: 'Quart', value: 'qt' },
      { title: 'Ounce', value: 'oz' }
    ];
    const found = unitOptions.find(option => option.value.toLowerCase() === value.toLowerCase());
    return found ? found.title : '';
  },
  isValidURL(url: string): boolean {
    if (!url) return false;

    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  },
  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
  isValidNumberDecimal(value: string, maxDigits = 7, maxDecimals = 2) {
    const regex = new RegExp(`^\\d{0,${maxDigits}}(\\.\\d{0,${maxDecimals}})?$`);
    return regex.test(value);
  },
  fullMonthDateFormat(date: any) {
    const dt = new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
    return dt;
  },
  isValidNumber(value: string) {
    return /^[0-9]*$/.test(value);
  },
  showSingleError(msg: string) {
    toast.error(msg, {
      toastId: "single-error-toast", // Ensures only one error toast exists
      autoClose: 4000,
      delay: 100,
    });
    toast.dismiss(); // Removes all previous toasts
  },
  parseTimeToMinutes(timeStr: string) {
    if (!timeStr || typeof timeStr !== "string") return NaN;

    // handle "HH:MM:SS"
    const parts = timeStr.split(":");
    if (parts.length === 3) {
      const h = parseInt(parts[0]);
      const m = parseInt(parts[1]);
      const s = parseInt(parts[2]);
      if (isNaN(h) || isNaN(m) || isNaN(s)) return NaN;

      return h * 60 + m + Math.floor(s / 60);
    }

    // handle plain minutes "20"
    const mins = Number(timeStr);
    return isNaN(mins) ? NaN : mins;
  },
  removeUnderscores(str: string) {
    return this.titleCase(str.replace(/_/g, ' '));
  },
  getUtcFormatedTime(date: any) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format("hh:mm A");
    }
  },

};


export default HelperService;
